module.exports = __webpack_public_path__ + "static/Busfinder_Pin_240.png";